import axios from 'axios';

import {
  CUSTOMER_GROUPS_URL,
  CUSTOMERS_URL,
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';

/**
 *
 * @param {String} name // Desired group name
 * @param {Func} handleSuccess
 * @param {Func} handleFailure
 */
export function createGroup(name, handleSuccess, handleFailure) {
  return axios({
    method: 'post',
    url: CUSTOMER_GROUPS_URL,
    data: {
      Name: name,
    },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}

/**
 *
 * @param {Number} customerGroupId // Id of group to delete
 * @param {Func} handleSuccess
 * @param {Func} handleFailure
 */
export function deleteGroup(customerGroupId, handleSuccess, handleFailure) {
  return axios({
    method: 'delete',
    url: `${CUSTOMER_GROUPS_URL}${customerGroupId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}

/**
 *
 * @param {Number} customerGroupId // Id of group details to fetch
 * @param {Func} handleSuccess
 * @param {Func} handleFailure
 */
export function fetchCustomerGroupsDetail(customerGroupId, handleSuccess, handleFailure) {
  return axios({
    method: 'get',
    url: `${CUSTOMER_GROUPS_URL}${customerGroupId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}

/**
 *
 * @param {ArrayOf(Numbers)} customerIds // List of customers to add to specified group
 * @param {String} customerGroupName // Name of group
 * @param {Number} customerGroupId // Id of group
 * @param {Func} handleSuccess
 * @param {Func} handleFailure
 */
export function saveCustomerList(customerIds, customerGroupName, customerGroupId, handleSuccess, handleFailure) {
  return axios({
    method: 'put',
    url: `${CUSTOMER_GROUPS_URL}${customerGroupId}`,
    data: {
      customer_ids: customerIds,
      Name: customerGroupName,
    },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}

/**
 *
 * @param {Func} handleSuccess
 * @param {Func} handleFailure
 */
export function fetchCustomerGroups(handleSuccess, handleFailure) {
  return axios({
    method: 'get',
    url: CUSTOMER_GROUPS_URL,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}

/**
 *
 * @param {Func} handleSuccess
 * @param {Func} handleFailure
 */
export function fetchCustomers(handleSuccess, handleFailure) {
  return axios({
    method: 'get',
    url: `${CUSTOMERS_URL}list`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err.data);
    });
}



// WEBPACK FOOTER //
// ./master/jsx/actions/groupList_actions.jsx